import styled from 'styled-components'

import { Label } from '../shared-form-styles'

export const IconGroupLabel = styled(Label)`
  margin-top: ${o => o.theme.spacing(5)};
  margin-bottom: ${o => o.theme.spacing(2)};
  color: ${o => o.theme.color.stroke.neutral.border.interaction.secondary.on.background};

  &:first-of-type {
    margin-top: ${o => o.theme.spacing(3)};
  }
`
